import React from 'react';
import { Grid, Box } from '@material-ui/core';
import { useQuery, gql } from '@apollo/client';
import { makeStyles } from '@material-ui/core/styles';
import MultiColumnsSelection from '../components/multiColumnsDropDown/MultiColumnsSelection';
import Chapter from './Chapter';

const useStyles = makeStyles(theme => ({
  //   root: {
  //     display: 'flex'
  // flexWrap: 'wrap',
  // '& > *': {
  //   margin: theme.spacing(1),
  //   width: theme.spacing(16),
  //   height: theme.spacing(16)
  // }
  //   }
  root: {
    flexGrow: 1
  },
  paper: {
    height: 140,
    width: 100
  },
  control: {
    padding: theme.spacing(2)
  }
}));

function SoSanhChuong() {
  const classes = useStyles();
  const [bible, setBible] = React.useState({
    version: 'V02',
    book: 'V02B43',
    chapter: 'V02B43C001',
    leftVersion: 'V01',
    leftChapter: 'V01B43C001',
    rightVersion: 'V02',
    rightChapter: 'V02B43C001',
    bookSelectedIndex: 42,
    chapterSelectedIndex: 0,
    leftSelectedVersionIndex: 0,
    rightSelectedVersionIndex: 1
  });

  const versionQuery = gql`
    {
      versions {
        id
        name
        shortName
      }
    }
  `;
  const booksQuery = gql`
    query($id: String!) {
      bible(id: $id) {
        id
        name
      }
    }
  `;

  const chaptersQuery = gql`
    query($id: String!) {
      book(id: $id) {
        chaptersId {
          id
          chapterNumber
        }
      }
    }
  `;

  const chapterQuery = gql`
    query($id: String!) {
      chapter(id: $id) {
        title
        chapterNum
        textDirection
        wordForChapter
        paragraph {
          id
          subtitle
          verse {
            id
            verseNum
            text
            startVerse
          }
        }
      }
    }
  `;
  const { data: versions } = useQuery(versionQuery);

  const { data: booksData } = useQuery(booksQuery, {
    variables: { id: bible.version }
  });

  const { data: { book: { chaptersId } = {} } = {} } = useQuery(chaptersQuery, {
    variables: { id: bible.book }
  });
  const chaptersIdData =
    chaptersId &&
    chaptersId.map(chapterId => {
      return { ...chapterId, name: chapterId.chapterNumber };
    });
  const { data: leftChapterData } = useQuery(chapterQuery, {
    variables: { id: bible.leftChapter }
  });
  const { data: rightChapterData } = useQuery(chapterQuery, {
    variables: { id: bible.rightChapter }
  });
  const leftVersionChange = index => {
    const selectedVersion = versions.versions[index].id;
    setBible({
      ...bible,
      leftVersion: selectedVersion,
      leftChapter: bible.chapter.replace(bible.version, selectedVersion),
      leftSelectedVersionIndex: index
    });
  };

  const rightVersionChange = index => {
    const selectedVersion = versions.versions[index].id;
    setBible({
      ...bible,
      rightVersion: selectedVersion,
      rightChapter: bible.chapter.replace(bible.version, selectedVersion),
      rightSelectedVersionIndex: index
    });
  };
  const bookChange = index => {
    const selectedBook = booksData && booksData.bible[index];
    const leftChapterId = selectedBook.id.concat('C001').replace(bible.version, bible.leftVersion);
    const rightChapterId = selectedBook.id
      .concat('C001')
      .replace(bible.version, bible.rightVersion);
    setBible({
      ...bible,
      book: selectedBook && selectedBook.id,
      chapter: selectedBook && selectedBook.id.concat('C001'),
      bookSelectedIndex: index,
      chapterSelectedIndex: 0,
      leftChapter: leftChapterId,
      rightChapter: rightChapterId
    });
  };
  const chapterChange = index => {
    const chapterSelected = chaptersId && chaptersId[index];
    console.log('selected chapter', chapterSelected.id);
    const rightChapterId = chapterSelected.id.replace(bible.version, bible.rightVersion);
    const leftChapterId = chapterSelected.id.replace(bible.version, bible.leftVersion);
    setBible({
      ...bible,
      chapter: chapterSelected.id,
      chapterSelectedIndex: index,
      rightChapter: rightChapterId,
      leftChapter: leftChapterId
    });
  };
  return (
    <div style={{ padding: 20 }}>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Grid item xs={6}>
          <MultiColumnsSelection
            id="booksList"
            cols={2}
            data={booksData && booksData.bible}
            onSelect={bookChange}
            defaultValue={bible.bookSelectedIndex}
          />
        </Grid>
        <Grid item xs={6}>
          <MultiColumnsSelection
            id="chaptersList"
            cols={chaptersId && chaptersId.length < 5 ? chaptersId.length : 5}
            data={chaptersIdData}
            onSelect={chapterChange}
            defaultValue={bible.chapterSelectedIndex}
          />
        </Grid>
        {/* </Grid> */}
      </Box>
      <Grid container className={classes.root} spacing={2} style={{ padding: 20 }}>
        {/* <Paper variant="outlined" key="left"> */}
        <Grid item xs={6} justifyContent="center" alignItems="center">
          <MultiColumnsSelection
            id="versionsList"
            cols={1}
            data={versions && versions.versions}
            onSelect={leftVersionChange}
            defaultValue={bible.leftSelectedVersionIndex}
          />
          <Chapter chapterData={leftChapterData && leftChapterData.chapter} />
        </Grid>
        {/* </Paper> */}
        {/* <Paper variant="outlined" key="right"> */}
        <Grid item xs={6}>
          <MultiColumnsSelection
            id="versionsList"
            cols={1}
            data={versions && versions.versions}
            onSelect={rightVersionChange}
            defaultValue={bible.rightSelectedVersionIndex}
          />
          <Chapter chapterData={rightChapterData && rightChapterData.chapter} />
        </Grid>
        {/* </Paper> */}
      </Grid>
    </div>
  );
}
export default SoSanhChuong;
